
import { defineComponent } from "vue";
// 展示图片
import "viewerjs/dist/viewer.css";
import { api as viewerApi } from "v-viewer";
export default defineComponent({
  props: {
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    showBig(index, item) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const $viewer = viewerApi({
        options: {
          toolbar: false,
          url: "url",
          initialViewIndex: 0,
          title: function() {
            return item.fieldName;
          },
          inline: true
        },
        images: [{ url: item.fieldContent, label: item.fieldName }]
      });
    }
  }
});
